<div class="p-6 gap-y-6 flex flex-col max-w-[480px] box-border">
  <div class="flex gap-x-4 items-center">
    <div class="p-2 h-10 box-border bg-green-90 text-neutral-10 rounded-[8px]">
      <mat-icon class="text-green-10" svgIcon="notification"/>
    </div>
    <span class="headline-small">{{ 'NOTIFICATION_SETTINGS.TITLE' | translate }}</span>
  </div>

  <span class="body-medium">{{ 'NOTIFICATION_SETTINGS.TEXT' | translate }}</span>

  <div id="notification-settings-panel"
       class="flex items-center justify-between gap-x-6 p-4 bg-white
              rounded-[16px] border border-solid border-neutral-90">
    <div class="flex flex-col">
      <span class="title-medium">{{ 'NOTIFICATION_SETTINGS.TITLE_2' | translate }}</span>
      <span class="body-medium">{{ 'NOTIFICATION_SETTINGS.TEXT_2' | translate }}</span>
    </div>

    <mat-slide-toggle [(ngModel)]="editedNotificationSettings.notificationsDailyEnabled"/>
  </div>

  <button id="notification-settings-done-button"
          mat-flat-button
          [mat-dialog-close]="editedNotificationSettings"
          class="ml-[auto] text-white">{{ 'DONE' | translate }}
  </button>
</div>
